import { Moment } from 'moment'
import { IBaseDtoType } from './common.type'

export interface IChallengesBase {
  name: string
  description: string
  trai_pool: number
  start_date: Date
  end_date: Date
  paid: boolean
}

export interface IChallengesBaseWithId extends IChallengesBase, IBaseDtoType { }

export interface IChallengesForm {
  name: string
  description: string
  trai_pool: number
  start_date: Moment
  end_date: Moment
  paid: boolean
}

export interface IUpdateChallengesDto extends IChallengesBase { }

export interface IUpdateChallengesDtoWithId extends IChallengesBase {
  id: string
}

export interface ICreateChallengesDto extends IChallengesBase { }

export interface IChallengesWithAdditionalData extends IChallengesBaseWithId {
  pending_scans_to_approve: number
}

export interface IChallengesRespDto {
  count: number
  data: IChallengesWithAdditionalData[]
}

export interface IChallengeInfoRespDto {
  pending_scans_to_approve: number
}

export enum EConsumerChallengeStatus {
  ONGOING = 'ongoing',
  PAID = 'paid',
  PROCESSING = 'processing',
}

export interface IChallengesLiderboardItem {
  name: string
  wallet_address: string
  points: number
  trai: number
}

export interface IChallengesUserPlacement {
  position: number
  wallet_address: string
  points: number
  trai: number
}

export interface IChallengeWithStats extends IChallengesBaseWithId {
  scans_created: number
  unique_scanners: number
  leaderboard: IChallengesLiderboardItem[];
  userPlacement: IChallengesUserPlacement | null
  status: EConsumerChallengeStatus
  totalPoints: number
}

export interface IConsumerChallengesRespDto {
  count: number
  data: IChallengeWithStats[]
}

export interface IChallengesLiderboardItemWithImage extends IChallengesLiderboardItem {
  image: string | null
}

export interface IChallengesUserPlacementWithImage extends IChallengesUserPlacement {
  name: string
  image: string | null
}

export interface ILeaderboardItem {
  leaderboard: IChallengesLiderboardItemWithImage[]
  count: number
  userPlacement: IChallengesUserPlacementWithImage
  traiPool?: number
  totalPoints?: number
}

export interface ILeaderboardOngoingItem extends ILeaderboardItem {
  name: string
  description: string
  endDate: Date
}

export interface ILeaderboardRespDto {
  total: ILeaderboardItem
  ongoing: ILeaderboardOngoingItem[]
}
